import React, { useEffect, useState } from "react";
import FullScreenLoader from "../FullScreenLoader";
import ErrorModal from "../ErrorModal";
import { subscribe, clearError } from "../../ui/globalUI";

export default function UIOverlayProvider({ children }) {
  const [state, setState] = useState({ activeRequests: 0, errorMessage: "" });

  useEffect(() => {
    const unsubscribe = subscribe(setState);
    return unsubscribe;
  }, []);

  return (
    <>
      {children}
      {state.activeRequests > 0 && <FullScreenLoader />}
      {state.errorMessage && (
        <ErrorModal message={state.errorMessage} onClose={() => clearError()} />
      )}
    </>
  );
}

